import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Objects, Parts, Types} from "components/index";
import GoogleMapReact from "google-map-react";
import API from "@beardeddevops/react.api";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Select from "react-select";
import Person from "@material-ui/icons/Person"
import {Circle} from '@react-google-maps/api'
import {Polygon} from '@react-google-maps/api'
import {Button} from "reactstrap";
import moment from "moment";
import {isEmptyObject} from "jquery";
import Paper from "@material-ui/core/Paper";
import {Slider} from "@material-ui/core";
import UserRoles from "../../constants/UserRoles";
import {getGoogleMapBootstrapURLKeys} from "../../constants/GoogleMaps";
import {isEmpty} from "lodash";
import Home from "@material-ui/icons/Home";
import {confirmAlert} from "react-confirm-alert";
export default class HiringZonesMap extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Hiring_Candidate._name);

		this.state.coords = [];
		this.state.hiringZones = [];
		this.state.key = 0;
		this.state.addZone = false;
		this.state.regions = [];
		this.state.selectedRegion = {
			pkey: 1,
			name: "Phoenix (602, 480, 623)",
			latitude: 33.4484000,
			longitude: -112.0740000,
		};
		this.state.defaultCenter = {
			lat: 33.4484000,
			lng: -112.0740000
		}
	}

	async componentDidMount() {
		this.setState({loading: true, items: []})
		await this.getZones()
		await this.getRegions()
		//get zones here

	}

	

	apiIsLoaded = (map, maps) => {
		this.setState({map, maps})
	};

	getZones = async () => {
		this.setState({hiringZones: []})
		if (this.state.map) {
			const latLng = new this.state.maps.LatLng(this.state.selectedRegion.latitude, this.state.selectedRegion.longitude); // Makes a latlng
			this.state.map.panTo(latLng);
			this.state.map.setZoom(9)
		}
		//get zones here
		let zoneModel = new API.BuildClass(Types.Hiring_Zone._name, API.RequestType.READ_ALL);
		zoneModel.filter = {
			'region': this.state.selectedRegion.pkey,
			'admin': true
		}
		zoneModel = await zoneModel.submit(null, 'GET_ALL');

		this.setState({hiringZones: zoneModel.items ?? []})

	}

	getRegions = async () => {
		let model = new API.BuildClass(Types.Regions._name, API.RequestType.READ_ALL);
		this.read = 'GET_ALL';
		model.limit = 5000;
		try {
			this.regions = await model.submit(null, this.read);
			this.regions = Object.keys(this.regions).map((key) => this.regions[key]);
			this.regions = this.regions[3];
			this.regions = this.regions.sort(function (a, b) {
				return a.name.localeCompare(b.name)
			})
			this.regions = this.regions.filter((region) => {
				return region.latitude > 0 || region.latitude < 0
			})
			this.setState({
				regions: this.regions,
				selectedRegion: this.regions.find((item) => item.pkey === this.state.selectedRegion.pkey)
			});
		} catch (error) {
		}
	}

	formatOptionLabel = ({label, showRedDot}) => {
		return (
			<div style={{ display: 'flex', alignItems: 'center' }}>
				{label}
				{showRedDot && <span style={{ color: 'red', marginLeft: 8 }}>• Hiring</span>}
			</div>
		)
	};

	render() {
		let zoom = 9;
		let extras = {};

		let {properties} = this.model

		let object = this.state;

		return (
			<Card>
				<CardContent>
					<div>
						<div className={"table-bar"}>
							<div className={'row'}>

								<div className={'col-3'} style={{display: 'flex', flexDirection: 'column'}}>
									<Select
										key={this.state.regions}
										placeholder={"Region Select"}
										value={{value: this.state.selectedRegion.pkey, label: this.state.selectedRegion.name, showRedDot: this.state.selectedRegion.active_zone === 'true'}}
										onChange={async (value) => {
											//this.setState({selectedRegion: this.state.regions.find((region) => region.pkey === value.value)})
											this.state.selectedRegion = this.state.regions.find((region) => region.pkey === value.value)
											await this.getZones()
										}}
										formatOptionLabel={this.formatOptionLabel}
										options={this.state.regions?.map(region => {
											return (
												{value: region.pkey, label: region.name, showRedDot: region.active_zone === 'true'}
											)
										})}
										styles={{
											singleValue: (provided, state) => ({
												...provided,
												display: 'flex',
												alignItems: 'center'
											}),
											option: (provided, state) => ({
												...provided,
												display: 'flex',
												alignItems: 'center'
											})
										}}
									/>
								</div>
								{this.props.showButtons && <div className={'col-1 text-right'}>
									<Button color={'primary'} size={'sm'} onClick={async () => {
										if (!this.state.addZone) {
											this.setState({addZone: true, zoneSelected: null, zoneId: null})
										} else {
											if (object.coords.length < 3) {
												alert('You have to have at least 3 points to save a Hiring Zone.')
												this.setState({addZone: false})
												return;
											}
											if (this.state.re_zone) {
												let zoneModel = new API.BuildClass(Types.Hiring_Zone._name, API.RequestType.READ_ALL);
												zoneModel.object.coords = JSON.stringify(object.coords);
												zoneModel.pkey = this.state.re_zone;
												zoneModel.object.pkey = this.state.re_zone;
												zoneModel.object.region = this.state.selectedRegion.pkey;
												await zoneModel.submit(null, 'POST');
											} else {
												let zoneModel = new API.BuildClass(Types.Hiring_Zone._name, API.RequestType.READ_ALL);
												zoneModel.object.coords = JSON.stringify(object.coords);
												zoneModel.object.region = this.state.selectedRegion.pkey;
												await zoneModel.submit(null, 'PUT');
											}
											await this.getZones();
											this.setState({coords: [], addZone: false, re_zone: null})
										}
									}}>{this.state.addZone ? 'Save Hiring Zone' : 'Add Hiring Zone'}</Button>
								</div>}

								{this.props.showButtons && <div className={'col-1 text-right'}>
									<Button color={'danger'} disabled={!this.state.zoneSelected} size={'sm'} onClick={async () => {
										let zoneModel = new API.BuildClass(Types.Hiring_Zone._name, API.RequestType.DELETE);
										zoneModel.object.pkey = this.state.zoneId;
										await zoneModel.submit(null, 'DELETE');
										await this.getZones();
										this.setState({zoneSelected: false, re_zone: null, coords: [], addZone: false, selectedCoords: []})
									}}>Delete Zone</Button>
								</div>}

								{this.props.showButtons && <div className={'col-1 text-right'}>
									<Button color={'warning'} disabled={!this.state.zoneSelected} size={'sm'} onClick={async () => {
										if (this.state.re_zone) {
											this.setState({re_zone: null, addZone: false, coords: []})
										} else {
											this.setState({re_zone: this.state.zoneId, addZone: true, coords: []})
										}
									}}>{this.state.re_zone ? 'Cancel Re-Draw' : 'Re-Draw Zone'}</Button>
								</div>}

								{this.props.showButtons && <div className={'col-1 text-right'}>
									<Button color={'info'} size={'sm'} onClick={async () => {
										this.setState({coords: []})
									}}>Clear Coords</Button>
								</div>}

								{this.props.showButtons && <div className={'col-1 text-right'}>
									<Button color={'info'} disabled={!this.state.zoneSelected} size={'sm'} onClick={async () => {
										let zoneModel = new API.BuildClass(Types.Hiring_Zone._name, API.RequestType.READ_ALL);
										zoneModel.object.coords = object.selectedCoords;
										zoneModel.pkey = this.state.zoneId;
										zoneModel.object.pkey = this.state.zoneId;
										zoneModel.object.region = this.state.selectedRegion.pkey;
										zoneModel.object.pause = !!!this.state.selectedZone.pause;
										await zoneModel.submit(null, 'POST');
										await this.getZones();
										this.setState({
											zoneSelected: false,
											re_zone: null,
											coords: [],
											addZone: false,
											selectedCoords: [],
											selectedZone: null,
											zoneId: null
										})
									}}>{this.state.selectedZone?.pause ? 'Resume Zone' : 'Pause Zone'}</Button>
								</div>}


								<div className={this.props.showButtons ? 'col-4' : 'col-9'} style={{display: 'flex', justifyContent: 'flex-end'}}>
									<b>Legend:</b>
									<ul>
										{this.props.showButtons && <li style={{display: 'flex', marginRight: '20px', alignItems: 'center'}}>
											<div style={{
												width: '20px',
												height: '20px',
												backgroundColor: "#0000FF",
												display: 'inline-block',
												marginRight: '5px'
											}}></div>
											Selected / New Coords
										</li>}
										{this.props.showButtons && <li style={{display: 'flex', marginRight: '20px', alignItems: 'center'}}>
											<div style={{
												width: '20px',
												height: '20px',
												backgroundColor: "#808080",
												display: 'inline-block',
												marginRight: '5px'
											}}></div>
											Re-Draw Old Coords
										</li>}
										<li style={{display: 'flex', marginRight: '20px', alignItems: 'center'}}>
											<div style={{
												width: '20px',
												height: '20px',
												backgroundColor: "#FFFF00",
												display: 'inline-block',
												marginRight: '5px'
											}}></div>
											Paused
										</li>
										<li style={{display: 'flex', marginRight: '20px', alignItems: 'center'}}>
											<div style={{
												width: '20px',
												height: '20px',
												backgroundColor: "#FF0000",
												display: 'inline-block',
												marginRight: '5px'
											}}></div>
											Active
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div style={{height: '78vh', width: '100%'}}>
							<GoogleMapReact
								bootstrapURLKeys={getGoogleMapBootstrapURLKeys()}
								defaultCenter={object.defaultCenter}
								defaultZoom={zoom}
								yesIWantToUseGoogleMapApiInternals
								onGoogleApiLoaded={({map, maps}) => this.apiIsLoaded(map, maps)}
								ref={(ref) => {
									this.mapRef = ref;
								}}
								onClick={(obj) => {
									if (!this.props.showButtons) {
										return;
									}
									if (this.state.addZone) {
										const found = this.state.coords.filter((item) => {
											if (item.lat === obj.lat && item.lng === obj.lng) {
												return true;
											}
										})
										if (found.length === 0) {
											this.setState({coords: [...this.state.coords, {lat: obj.lat, lng: obj.lng}]})
										}
									}
								}}
								{...extras}
							>
								{object.coords.length > 0 &&
									<Polygon
										key={'poly'}
										options={{
											paths: this.state.coords,
											strokeColor: "#0000FF",
											strokeOpacity: 0.8,
											map: this.state.map
										}}
									/>
								}

								{object.hiringZones.map((item) => {
									let color = "#FF0000";
									if (this.state.zoneId === item.pkey) {
										if (this.state.re_zone) {
											color = "#808080"
										} else {
											color = "#0000FF"
										}
									} else if (item.pause) {
										color = "#FFFF00"
									}
									return (
										<>
											<Polygon
												key={'poly_' + item.pkey}
												options={{
													paths: JSON.parse(item.coords),
													strokeColor: color,
													strokeOpacity: 0.8,
													map: this.state.map,
													zIndex: 999
												}}
												onClick={(event) => {
													if (this.state.zoneSelected) {
														this.setState({zoneId: null, zoneSelected: false, selectedCoords: [], selectedZone: null})
													} else if (!this.state.addZone) {
														this.setState({
															zoneId: item.pkey,
															zoneSelected: true,
															selectedCoords: item.coords,
															selectedZone: item
														})
													}
												}}
											/>
										</>
									)
								})}
							</GoogleMapReact>
						</div>
					</div>
				</CardContent>
			</Card>
		)
	}
}
